import gql from 'graphql-tag';

import { IdentityDetails } from '../fragments/identity';
import { UserDetails } from '../fragments/account';
import { PhotoThumbnails } from '../fragments/album';

export const AlbumMembershipWithAccountIdentitiesForRedirect = gql`
  query albumMembershipWithAccountIdentitiesForRedirect(
    $albumMembershipId: RecordID!
  ) {
    albumMembership(id: $albumMembershipId) {
      id
      entitled_matched_photos {
        total
      }
      matched_photos_extended(slice: { limit: 1 }) {
        total
        records {
          id
          photo {
            id
            ...PhotoThumbnails
          }
        }
      }
      album {
        id
        root_album_folder {
          id
          price {
            value
            currency
          }
          name
          join_without_purchase
          album_price_mode
          album_delivery_modes {
            photo_finder
            shutterbug
          }
          individual_albums
        }
      }
    }
    me {
      id
      ...UserDetails
      linked_identities(relation: ALL, slice: { limit: 99 }) {
        records {
          ...IdentityDetails
        }
      }
    }
  }
  ${IdentityDetails}
  ${UserDetails}
  ${PhotoThumbnails}
`;
